import { debounce } from "lodash";

const debounceHandler = () => {
  const debouncedCallback = ({
    debounceRef,
    callback,
    delay = 500,
  }: {
    debounceRef: any;
    callback: () => void;
    delay?: number;
  }) => {
    if (debounceRef.current) {
      debounceRef.current.cancel();
    }

    debounceRef.current = debounce(() => {
      callback();
    }, delay);

    debounceRef.current();
  };

  return {
    debouncedCallback,
  };
};

export default debounceHandler;
